import "./App.css";
import React, { useState, useMemo } from "react";
import UserContext from "./context/userContext";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Header from "./page/layout/header";
import Footer from "./page/layout/footer";
import Home from "./page/home";

function App() {
  const [currentColor, setCurrentColor] = useState("#000000");
  const [currentSize, setCurrentSize] = useState(5);
  const [clear, setClear] = useState(false);
  const [currentTool, setCurrentTool] = useState("Normal");
  const [undoStatus, setUndoStatus] = useState(false);
  const [redoStatus, setRedoStatus] = useState(false);
  const [areaFocus, setAreaFocus] = useState(false);
  const [currentMouseX, setCurrentMouseX] = useState(0);
  const [currentMouseY, setCurrentMouseY] = useState(0);
  const [backgroundImage, setBackgroundImage] = useState('image_1.png');

  const value = useMemo(
    () => ({
      currentColor,
      setCurrentColor,
      currentSize,
      setCurrentSize,
      clear,
      setClear,
      currentTool,
      setCurrentTool,
      undoStatus,
      setUndoStatus,
      redoStatus,
      setRedoStatus,
      areaFocus,
      setAreaFocus,
      currentMouseX,
      setCurrentMouseX,
      currentMouseY,
      setCurrentMouseY,
      backgroundImage,
      setBackgroundImage
    }),
    [
      currentColor,
      currentSize,
      clear,
      currentTool,
      undoStatus,
      redoStatus,
      areaFocus,
      currentMouseX,
      currentMouseY,
      backgroundImage
    ]
  );
  return (
    <div className="App ">
      <UserContext.Provider value={value}>
        <Router>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
          <Footer />
        </Router>
      </UserContext.Provider>
    </div>
  );
}

export default App;
